module.exports = "/assets/gift-events-listing/GIFT25-banner-desktop.png?hNcchdo";